import React from "react";
import PropTypes from "prop-types";
import { MdGTranslate } from "@react-icons/all-files/md/MdGTranslate";

const TranslateLink = ({ translationKey, language }) => (
  <a
    href={`${process.env.HERCULES_BACKEND_URL}translations?key=${translationKey}&language=${language}`}
    aria-label="translation"
    target="_blank" rel="noreferrer"
  >
    <MdGTranslate />
  </a>
);

TranslateLink.propTypes = {
  translationKey: PropTypes.string,
  language: PropTypes.string,
};

export default TranslateLink;
